import { RiskDashboardMetricData } from './../../risk-manager/risk-metric-functions';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { DashboardViewSelection } from './../../dashboard/dashboard-view-selection';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { Subscription } from 'rxjs';
import { AppConfig } from './../../app.config';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { NormalRiskMetricTiles, StressRiskMetricTiles } from '../../risk-manager/risk-metric-functions';

export enum RiskViewMode {
    METRIC,
    CHART
}

@Component({
    selector: 'app-home-sidebar-risk',
    templateUrl: './sidebar-risk.component.html',
    styleUrls: ['./../home.sidebar.component.scss', './sidebar-risk.component.scss']
})
export class SidebarRiskComponent implements OnInit, OnDestroy, AfterViewInit {
    categoryItems: MenuItem[];
    filterItems: MenuItem[];
    currencies: string[] = [];
    viewSelections: DashboardViewSelection<unknown>[] = [];
    selectedViewSelection: DashboardViewSelection<unknown>;
    selectedCurrency: string;
    subscription: Subscription;

    // sideBarOpen = false;

    constructor(
        private dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private appConfig: AppConfig) {
    }

    ngOnInit() {
        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        this.selectedCurrency = this.currencies[0];

        this.viewSelections = [
            {
                currency: this.selectedCurrency, type: 'Risk',
                metricBarConfigurator: new NormalRiskMetricTiles(),
                batchIdentifier: this.appConfig.getTodayString()
            },
            {
                currency: this.selectedCurrency, type: 'Stress',
                metricBarConfigurator: new StressRiskMetricTiles(),
                batchIdentifier: this.appConfig.getTodayString()
            },
        ];
        this.selectedViewSelection = this.viewSelections[0];
        this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
        // this.dashboardEventService.currencySelectionSubject.next(this.selectedCurrency);
        // this.sideBarOpen = false;
        this.subscription = this.dashboardEventService.viewSelectionSubject.subscribe({
            next: (viewSelection: DashboardViewSelection<RiskDashboardMetricData>) => {
                this.selectedViewSelection = viewSelection;
                this.selectedCurrency = viewSelection.currency;
            }
        });
        /*
        this.subscription = this.dashboardEventService.currencySelectionSubject.subscribe({next: (currency: string) => {
            this.selectedCurrency = currency;
        });
        */
        // this.subscription.add(this.dashboardEventService.dashboardMetricCategorySubject
        //     .subscribe({next: (dashboardMetricCategory: DashboardMetricCategory) => {
        //     if (dashboardMetricCategory) {
        //         const matchingMenuItem = this.findMatchingConfigMenuItem(dashboardMetricCategory, this.categoryItems);
        //         if (matchingMenuItem) {
        //             matchingMenuItem.expanded = true;
        //         }
        //     }
        // }));


        // const configsByCategory = RISK_GRAPHICAL_CONFIGS.reduce((grouped, config) => {
        //     const key = config.category.label;
        //     grouped[key] = grouped[key] || [];
        //     grouped[key].push(config);
        //     return grouped;
        // }, {});
        // this.categoryItems = [];
        // this.categoryItems.push({
        //     label: 'Dashboard',
        //     command: (event) => {
        //         this.dashboardEventService.dashboardMetricCategorySubject.next(null);
        //         // this.dashboardEventService.toggleSideBarSliderSubject.next(false);
        //     },
        // });
        // this.categoryItems.push(...Object.keys(configsByCategory)
        //     .map((categoryLabel: string) => {
        //         let category: DashboardMetricCategory;
        //         const items = [];
        //         const configsBySubCategory = configsByCategory[categoryLabel]
        //             .filter((config: DashboardGraphicalConfig) => {
        //                 return (config.subCategory);
        //             })
        //             .reduce((grouped, config) => {
        //                 const key = config.subCategory;
        //                 grouped[key] = grouped[key] || [];
        //                 grouped[key].push(config);
        //                 return grouped;
        //             }, {});
        //         Object.keys(configsBySubCategory)
        //             .forEach((subCategory: string) => {
        //                 const subCategoryItems = [];
        //                 configsBySubCategory[subCategory]
        //                     .forEach((config: DashboardGraphicalConfig) => {
        //                         category = config.category;
        //                         subCategoryItems.push({
        //                             label: config.label.replace(subCategory, ''),
        //                             // icon: this.getMenuIcon(config),
        //                             config: config,
        //                             command: (event) => { this.dashboardEventService.DashboardGraphicalConfigSubject.next(event.item.config) }
        //                         });
        //                     });
        //                 items.push({
        //                     label: subCategory,
        //                     items: subCategoryItems
        //                 })
        //             });
        //         configsByCategory[categoryLabel]
        //             .forEach((config: DashboardGraphicalConfig) => {
        //                 category = config.category;
        //                 if (!config.subCategory) {
        //                     items.push({
        //                         label: config.label,
        //                         // icon: this.getMenuIcon(config),
        //                         config: config,
        //                         command: (event) => { this.dashboardEventService.DashboardGraphicalConfigSubject.next(event.item.config) }
        //                     });
        //                 }
        //             })
        //         return {
        //             label: categoryLabel,
        //             items: items,
        //             category: category,
        //             command: (event) => { this.dashboardEventService.dashboardMetricCategorySubject.next(event.item.category) }
        //         }
        //     })
        // );
        // const preference = this.snapshotService.applicationConfiguration;
        // this.filterItems = [
        //     // { label: 'Account'}
        // ];
        // // this.filterItems.concat(preference.accountNamesa


    }

    // findMatchingConfigMenuItem(dashboardMetricCategory: DashboardMetricCategory, menuItems: any[]): any {
    //     if (menuItems) {
    //         for (const menuItem of menuItems) {
    //             if (menuItem.category === dashboardMetricCategory) {
    //                 return menuItem;
    //             } else {
    //                 const foundItem = this.findMatchingConfigMenuItem(dashboardMetricCategory, menuItem.items);
    //                 if (foundItem) {
    //                     return foundItem;
    //                 }
    //             }
    //         }
    //     }
    // }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
    }

    initializeSideBar() {
    }

    onCurrencyChange(event: MatButtonToggleChange) {
        this.selectedViewSelection.currency = event.value;
        this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
    }

    onViewChange(event: MatButtonToggleChange) {
        this.selectedViewSelection = event.value;
        this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
    }

    flagIconClass(block) {
        const flagCode = CurrencyDisplayUtil.flagCodeForCurrency(block);
        if (!flagCode) {
            return '';
        }
        return 'flag-icon flag-icon-' + flagCode;
    }
    // getMenuIcon(config: DashboardGraphicalConfig): string {
    //     switch (config.chartType) {
    //         case 'DefaultPie':
    //             return 'fa-pie-chart';
    //         case 'DefaultLine':
    //         case 'TimeLine':
    //             return 'fa-line-chart';
    //         case 'DefaultColumn':
    //             return 'fa-bar-chart';
    //         default:
    //             return 'fa-circle-o';
    //     }

    // }

    // closeSideBar() {
    //     this.sideBarOpen = false;
    //     this.dashboardEventService.toggleSideBarSliderSubject.next(false);
    // }

    // toggleSideBar(flag?: boolean) {
    //     this.sideBarOpen = !this.sideBarOpen;
    //     this.dashboardEventService.toggleSideBarSliderSubject.next(this.sideBarOpen);
    // }
}
